<template>
  <Rule :ruleContent="ruleContent" />
</template>

<script>
import { mapState } from 'vuex';
import Rule from '@/components/templates/common/Rule';

export default {
  components: { Rule },
  computed: {
    ...mapState('app/demo', {
      ruleContent: state => state.actData.activityRule
    })
  }
};
</script>
